import { useSelector } from "react-redux";
import AdminDashboard from "../AdminDashboard";
import ClientDashboard from "../ClientDashboard";
import PrestataireDashboard from "../PrestataireDashboard";
import DonneurOrdreDashboard from "../DonneurOrdreDashboard";

export default function DashboardRouter() {
  const { user } = useSelector((state) => state.auth);

  if (!user) return <p>Veuillez vous connecter</p>;

  if (user.rolesUser.some(role => role.roleUser === "admin")) {
    return <AdminDashboard />;
  }

  if (user.rolesUser.some(role => role.roleUser === "client")) {
    return <ClientDashboard />;
  }

  if (user.rolesUser.some(role => role.roleUser === "prestataire")) {
    return <PrestataireDashboard />;
  }

  if (user.rolesUser.some(role => role.roleUser === "donneur_ordre")) {
    return <DonneurOrdreDashboard />;
  }
  return <p>Aucun dashboard disponible pour votre rôle.</p>;
}
